import { Component, forwardRef, OnInit } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  templateUrl: './affiliate-login-settings.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AffiliateLoginSettingsComponent),
      multi: true,
    },
  ],
})
@DestroySubscribers()
export class AffiliateLoginSettingsComponent implements ControlValueAccessor, OnInit {
  public onChange: (value: any) => void = () => {};
  public onTouch = () => {};
  public subscribers: Record<string, Subscription> = {};

  public form = new UntypedFormGroup({
    defaultId: new UntypedFormControl(null, Validators.required),
    buttonsColor: new UntypedFormControl(null),
    textColor: new UntypedFormControl(null),
    buttonsColorEnabled: new UntypedFormControl(false),
    textColorEnabled: new UntypedFormControl(false),
    replaceCopyrightEnabled: new UntypedFormControl(false),
  });

  public ngOnInit(): void {
    this.subscribers.formChanges = this.form.valueChanges.pipe(debounceTime(100)).subscribe((value) => {
      this.onChange(JSON.stringify(value));
      this.onTouch();
    });
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public writeValue(obj: any): void {
    try {
      this.form.patchValue(JSON.parse(obj));
    } catch {}
  }

  public validate(): ValidationErrors | null {
    return this.form.invalid ? { errors: true } : null;
  }

  public get isButtonsColorEnabled(): boolean {
    return this.form.get('buttonsColorEnabled').value;
  }

  public get isTextColorEnabled(): boolean {
    return this.form.get('textColorEnabled').value;
  }
}
